import ShopType from "@/enum/ShopType";

export default class ListDecryptedConsigneeError extends Error {
    constructor(public message: string, public type: ShopType, public extraInfo?: any) {
        super();
    }
}
